<div fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="login-card">
        <mat-card-header>
            <h4>{{ "login.header" | translate }}</h4>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="loginForm">
                <div fxLayout="column" class="form-group">
                    <mat-form-field [ngStyle]="{
                      'width.ch': 30,
                      'min-width.px': 400
                    }">
                        <mat-label>{{ "login.username" | translate }}</mat-label>
                        <input matInput class="form-control" formControlName="username" />
                        <mat-error *ngIf="loginForm.controls['username'].errors">{{ "error.required" | translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field [ngStyle]="{
                      'width.ch': 30,
                      'min-width.px': 400
                    }">
                        <mat-label>{{ "login.password" | translate }}</mat-label>
                        <input matInput type="password" formControlName="password" class="form-control" #password/>
                        <mat-icon
                            style="cursor: pointer; font-size: 26px;"
                            matSuffix
                            (mousedown)="password.type = 'text'"
                            (mouseup)="password.type = 'password'"
                            [inline]="true">
                            {{ password.type == "password" ? "visibility_off" : "visibility" }}
                        </mat-icon>
                        <mat-error *ngIf="loginForm.controls['password'].errors">{{ "error.required" | translate }}</mat-error>
                    </mat-form-field>
                    <mat-checkbox formControlName="rememberMe" >{{ "login.remember_me" |
                        translate }}</mat-checkbox>
                    <div style="margin-top: 15px;">
                        <button mat-raised-button (click)="onSubmit()">
                            {{ "login.button" | translate }}
                        </button>
                    </div>
                    
                </div>               
            </form>
        </mat-card-content>
    </mat-card>
</div>